import { scrollIntoView } from 'squintjs'

let lastScrolled

export const scrollOnTimeUpdate = (event = {}, timestamps, options = {}) => {
  const { currentTime } = event.target || {}

  if (typeof currentTime !== 'number') {
    return
  }

  const { scrollDuration = 300, offset = '25%', scope } = options
  const now = Date.now()

  if (lastScrolled && now - lastScrolled < scrollDuration) {
    return
  }

  const currentTimestamp = findCurrentTimestamp(timestamps || [], currentTime)
  const element = (scope || document).querySelector(
    `[data="${currentTimestamp}"]`
  )
  lastScrolled = now

  if (!element) {
    return
  }

  const parent = findScrollingParent(element)

  if (!parent) {
    return
  }

  scrollIntoView(element, parent, {
    duration: scrollDuration,
    offset
  })

  if (options.highlight) {
    highlightCurrent(element, parent)
  }

  return true
}

const highlightCurrent = (element, parent) => {
  const highlightElement = parent.querySelector(
    '#scroll-into-view-current-indicator'
  )

  const elementY = element.getBoundingClientRect().y
  const parentY = parent.getBoundingClientRect().top
  const offset = elementY - parentY + parent.scrollTop

  if (highlightElement) {
    highlightElement.setAttribute(
      'style',
      `top: ${offset}px; height: ${element.offsetHeight}px`
    )
  } else {
    const newElement = document.createElement('div')
    newElement.id = 'scroll-into-view-current-indicator'
    newElement.classList.add('scroll-into-view-current-indicator')
    newElement.setAttribute(
      'style',
      `top: ${offset}px; height: ${element.offsetHeight}px`
    )
    parent.appendChild(newElement)
  }
}

const findCurrentTimestamp = (timestamps, currentTime) =>
  timestamps.find((time, index, array) => {
    const nextTime = array[index + 1]
    return !nextTime || nextTime > currentTime
  })

const findScrollingParent = element => {
  const parent = element.parentElement
  if (!parent) {
    return
  }

  const overflowY = window.getComputedStyle(parent)['overflow-y']
  const isScrollable = overflowY === 'scroll' || overflowY === 'auto'

  if (isScrollable && parent.scrollHeight >= parent.clientHeight) {
    return parent
  }

  return findScrollingParent(parent)
}

export const scrollOnTimeUpdateWithFeatures = (
  event = {},
  timestamps,
  options = {}
) => {
  return scrollOnTimeUpdate(
    event,
    timestamps,
    Object.assign(
      {
        highlight: Tru.Stores.reduxStore
          .getState()
          .features.includes('transcript_highlighting')
      },
      options
    )
  )
}



// WEBPACK FOOTER //
// ../src/utils/scrollOnTimeUpdate.js